import { Box, Button, Loader, Popover, TextButton } from '@wix/design-system';
import React from 'react';
import { dataHooks } from '../../../utils/datahooks';
export const RuleFooter = _ref => {
  let {
    submitButtonProps,
    dismissButtonProps,
    iconButton,
    dataHook,
    design
  } = _ref;
  const {
    showPopover,
    popoverContent
  } = submitButtonProps;
  const appliedMarginTop = (design == null ? void 0 : design.marginTop) ?? '0px';
  return /*#__PURE__*/React.createElement(Box, {
    align: "right",
    direction: "horizontal",
    gap: "SP2",
    marginTop: appliedMarginTop,
    verticalAlign: "middle"
  }, iconButton && /*#__PURE__*/React.createElement(Box, {
    dataHook: dataHooks.ruleFooterIconButton(dataHook)
  }, iconButton), dismissButtonProps && ((dismissButtonProps == null ? void 0 : dismissButtonProps.type) === 'button' ? /*#__PURE__*/React.createElement(Button, {
    dataHook: dataHooks.ruleFooterDismissButton(dataHook),
    disabled: dismissButtonProps.disabled,
    ellipsis: true,
    prefixIcon: dismissButtonProps.prefixIcon,
    priority: "secondary",
    size: "tiny",
    weight: "bold",
    onClick: dismissButtonProps.onClick
  }, dismissButtonProps.label) : /*#__PURE__*/React.createElement(TextButton, {
    children: dismissButtonProps.label,
    dataHook: dataHooks.ruleFooterDismissButton(dataHook),
    disabled: dismissButtonProps.disabled,
    ellipsis: true,
    priority: "secondary",
    size: "tiny",
    weight: "bold",
    onClick: dismissButtonProps.onClick
  })), /*#__PURE__*/React.createElement(Popover, {
    appendTo: "window",
    shown: showPopover,
    zIndex: 2000,
    showArrow: true
  }, /*#__PURE__*/React.createElement(Popover.Element, null, /*#__PURE__*/React.createElement(Button, {
    dataHook: dataHooks.ruleFooterSubmitButton(dataHook),
    disabled: submitButtonProps.disabled,
    ellipsis: true,
    prefixIcon: submitButtonProps.prefixIcon,
    priority: "primary",
    size: "tiny",
    onClick: submitButtonProps.onClick
  }, /*#__PURE__*/React.createElement(Box, {
    gap: "SP1",
    verticalAlign: "middle"
  }, submitButtonProps.label, submitButtonProps.showLoader && /*#__PURE__*/React.createElement(Loader, {
    dataHook: dataHooks.ruleFooterLoader(dataHook),
    size: "tiny"
  })))), /*#__PURE__*/React.createElement(Popover.Content, null, popoverContent)));
};
//# sourceMappingURL=rule-footer.js.map